import React, { useState } from "react";
import { AssetConfig } from "../utils/assets";
import "./ContactUs.css";

const ContactUs = () => {
  const [selectedOption, setSelectedOption] = useState("1");

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleNext = () => {
    // Handle next action based on selected option
    if (selectedOption === "1") {
      // Redirect to registration or survey page for respondents
      window.location.href = "/auth/register";
    } else {
      // Redirect to contact form or business inquiry page
      window.location.href = "mailto:business@diveinpanels.com";
    }
  };

  return (
    <div className="contact-us">
      <div className="contact-wrapper">
        <div className="contact-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <h1 className="page-title mb-4">Don't go yet; say hello</h1>

                <div className="form-wrapper select-form">
                  <div className="radio-group">
                    <div className="radio-option mb-3">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="contactOption"
                          value="1"
                          checked={selectedOption === "1"}
                          onChange={handleOptionChange}
                          className="radio-input"
                        />
                        <span className="radio-custom"></span>
                        <span className="radio-text">
                          Are you a new/existing survey respondent who has an
                          interest in filling online surveys that pay cash?
                        </span>
                      </label>
                    </div>

                    <div className="radio-option">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name="contactOption"
                          value="2"
                          checked={selectedOption === "2"}
                          onChange={handleOptionChange}
                          className="radio-input"
                        />
                        <span className="radio-custom"></span>
                        <span className="radio-text">
                          A fantastic brand/market research firm looking for
                          same help in legitimate and fast data collection.
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="form-footer d-flex mt-3">
                    <button
                      className="btn op-cta btn-shadow w-auto"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 d-flex justify-content-end align-items-center">
                <figure>
                  <img alt="Contact Us" src={AssetConfig.images.contact} />
                </figure>
              </div>
            </div>
          </div>

          <div className="pattern">
            <img alt="Contact Us" src="/assets/images/pattern/contact.png" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
